import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd3600a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-cta" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "cta-grid" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"cta-card order-card\" data-aos=\"fade-up\" data-aos-duration=\"800\" data-v-dd3600a8><div class=\"cta-icon\" data-v-dd3600a8><i class=\"ri-smartphone-line\" data-v-dd3600a8></i></div><h3 data-v-dd3600a8>Order Online</h3><p data-v-dd3600a8>Enjoy your favorites at home. Your favorite food is just a click away.</p><a href=\"#\" class=\"cta-link\" data-v-dd3600a8> Coming Soon <i class=\"ri-arrow-right-up-line\" data-v-dd3600a8></i></a></div><div class=\"cta-card catering-card\" data-aos=\"fade-up\" data-aos-duration=\"800\" data-aos-delay=\"200\" data-v-dd3600a8><div class=\"cta-icon\" data-v-dd3600a8><i class=\"ri-cake-3-line\" data-v-dd3600a8></i></div><h3 data-v-dd3600a8>Catering</h3><p data-v-dd3600a8>Creative menus, exceptional service. Make your event unforgettable with our catering packages.</p><a href=\"#\" class=\"cta-link\" data-v-dd3600a8> Coming Soon <i class=\"ri-arrow-right-up-line\" data-v-dd3600a8></i></a></div>", 2)
const _hoisted_6 = {
  class: "cta-card dinein-card",
  "data-aos": "fade-up",
  "data-aos-duration": "800",
  "data-aos-delay": "400"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cta-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-store-2-line" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Dine In", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Casual, family-friendly atmosphere. Visit us for a fresh, flavorful experience.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-up-line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("a", {
            href: "#location",
            class: "cta-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollToLocation && _ctx.scrollToLocation(...args)), ["prevent"]))
          }, [
            _createTextVNode(" Get Directions "),
            _hoisted_10
          ])
        ])
      ])
    ])
  ]))
}